var php_url_head = '/imeteo_11.2.4';

//# sourceMappingURL=imeteo.cee35bed.js.map
